import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Carousel } from "react-responsive-carousel";

interface SliderItem {
  id: number;
  image_url: string;
  name: string;
}

interface PotsSliderProps {
  potSliders: SliderItem[];
}

const PotsSlider = ({ potSliders }: PotsSliderProps) => {
  if (!potSliders.length) {
    return null;
  }

  return (
    <Box className="pots-slider-wrapper">
      <Typography
        className="pots-slider-title"
        style={{ fontSize: 24, fontWeight: "bold" }}
      >
        Factory Direct
        <br />
        Best Price Guaranteed
      </Typography>
      <Carousel
        showThumbs={false}
        showStatus={false}
        autoPlay
        infiniteLoop
        interval={5000}
        emulateTouch
      >
        {potSliders.map((item) => (
          <Box key={item.id} className="pots-slider-item">
            <Box
              component="img"
              className="pots-slider-image"
              src={item.image_url}
              alt={item.name || "Pot slider"}
            />
          </Box>
        ))}
      </Carousel>
    </Box>
  );
};

export type { SliderItem };
export default PotsSlider;
